import React from 'react';
import {
  EmptyFormRow,
  FieldInput,
  FormCol,
  FormCol12,
  FormRow,
  useIsFieldRequiredHook,
} from 'motion-components';
import { useFormikContext } from 'formik';
import { useRootStore } from 'store';
import { useHandleError } from 'shared-pages/services';
import { useTranslation } from 'react-i18next';
import { isActiveField } from 'shared-pages/common/form-helpfunc';
import { Col, Row } from 'react-bootstrap';
import { FileRepoField } from 'shared-pages/components/filerepo-field';
import { FileRepoImage } from 'shared-pages/components/filerepo-image';
import {
  FieldSelectCollector,
  FieldSelectContributor,
  FieldSelectDriver,
  FieldSelectUserType,
  FieldSelectWasteReceptionPoint,
  FormFieldCollectionPointDlg,
} from 'shared-pages/components';
import { UserTypeValues } from 'shared-pages';
import { isRebattery, isRebatteryLiion } from 'shared-pages/common/constants';
import { isReaction } from 'mobx/dist/internal';

export const FormFields = ({
  isNew,
  updateRecord,
  refetch,
  data,
  validationSchema = undefined,
}) => {
  //
  const { authStore, appStore } = useRootStore();
  const frmkCntx = useFormikContext();
  const { values }: { values: any } = frmkCntx;
  const isFieldRequired = useIsFieldRequiredHook(validationSchema);

  const { handleGraphqlError } = useHandleError('PiBaseFormFields');
  const { t } = useTranslation();

  function calcUserCanEdit() {
    const canEdit =
      appStore.isPlatformOwner ||
      (appStore.isCollector && (data?.usertypeId === UserTypeValues.CollectorDriver || isNew)) ||
      (appStore.isContributor &&
        (data?.usertypeId === UserTypeValues.Contributor ||
          (isRebatteryLiion && data?.usertypeId === UserTypeValues.CollectionPoint) ||
          isNew));
    const canEditReasoning = '';
    return { canEdit, canEditReasoning };
  }
  const { canEdit, canEditReasoning } = calcUserCanEdit();

  return (
    <>
      <div className="d-flex flex-row">
        <FormCol>
          <FieldInput
            label={t('Χρήστης')}
            name="userName"
            placeholder=""
            disabled={!isNew}
            required={isFieldRequired('userName', values)}
          />
          <FieldInput
            label={t('Όνομα Χρήστη')}
            name="firstName"
            placeholder=""
            disabled={!canEdit}
            required={isFieldRequired('firstName', values)}
          />
          <FieldInput
            label={t('Επώνυμο Χρήστη')}
            name="lastName"
            placeholder=""
            disabled={!canEdit}
            required={isFieldRequired('lastName', values)}
          />
          <FieldInput label={t('Θέση')} name="position" placeholder="" disabled={!canEdit} />
          <FieldInput label={t('Τηλέφωνο')} name="tel" placeholder="" disabled={!canEdit} />
          <FieldInput label={t('Κινητό')} name="mobile1" placeholder="" disabled={!canEdit} />
        </FormCol>

        {/* 2η Στήλη */}
        <FormCol>
          <FieldInput
            label={t('E-mail')}
            name="email"
            placeholder=""
            disabled={!canEdit}
            required={isFieldRequired('email', values)}
          />
          <FieldSelectUserType
            disabled={!canEdit}
            label={t('Τύπος Χρήστη')}
            required={isFieldRequired('usertypeId', values)}
          />

          {(values as any).usertypeId === UserTypeValues.Collector ? (
            <FieldSelectCollector
              disabled={!canEdit}
              label={t('Συλλέκτης')}
              name="referenceId"
              required={isFieldRequired('referenceId', values)}
            />
          ) : (values as any).usertypeId === UserTypeValues.CollectorDriver ? (
            <FieldSelectDriver
              disabled={!canEdit}
              label={t('Οδηγός')}
              name="referenceId"
              required={isFieldRequired('referenceId', values)}
            />
          ) : (values as any).usertypeId === UserTypeValues.WasteReceptionPoint ? (
            <FieldSelectWasteReceptionPoint
              disabled={!canEdit}
              label={t('Ανακυκλωτής/Αποθήκη')}
              name="referenceId"
              required={isFieldRequired('referenceId', values)}
            />
          ) : (values as any).usertypeId === UserTypeValues.Contributor ? (
            <FieldSelectContributor
              disabled={!canEdit}
              label={t('Υπόχρεος Εισφορών')}
              name="referenceId"
              required={isFieldRequired('referenceId', values)}
            />
          ) : (values as any).usertypeId === UserTypeValues.CollectionPoint ? (
            <FormCol12 style={{ padding: '0px' }}>
              <FormFieldCollectionPointDlg
                label={t('Σημείο Συλλογής')}
                disabled={!canEdit}
                idFieldName="referenceId"
                nameFieldName="userview.referenceName"
                // onChange={onCollectionPointIdChange}
                required={isFieldRequired('referenceId', values)}
              />
              {/* {errors.collectionPointId && (
                  <div className="invalid-feedback">{errors.collectionPointId}</div>
                )} */}
            </FormCol12>
          ) : (values as any).usertypeId === UserTypeValues.Contributor ? (
            <FieldSelectContributor
              disabled={!canEdit}
              label={t('Υπόχρεος Εισφορών')}
              name="referenceId2"
              required={isFieldRequired('referenceId2', values)}
            />
          ) : (
            <div style={{ minHeight: '41.98px' }}></div>
          )}

          <Row style={{ margin: 0, marginBottom: '-15px' }}>
            <FileRepoField
              as={Col}
              label={t('Αρχείο Υπογραφής')}
              fileIdFieldName="signatureFileId"
              fileRec={data?.signatureFileRec}
            />
            {values?.signatureFileId && data?.signatureFileRec?.id && (
              <FileRepoImage fileId={data?.signatureFileRec?.id} height="64px" />
            )}
          </Row>
        </FormCol>
        {/* 3η Στήλη */}
        <FormCol>
          {isActiveField(t, canEdit)}
          <EmptyFormRow />
          {isRebatteryLiion && (values as any).usertypeId === UserTypeValues.CollectionPoint && (
            <FieldSelectContributor
              disabled={!canEdit}
              label={t('Υπόχρεος Εισφορών')}
              name="referenceId2"
              required={isFieldRequired('referenceId2', values)}
            />
          )}
        </FormCol>
        {/* 4η Στήλη */}
        <FormCol></FormCol>
      </div>
      {(isRebatteryLiion || isRebattery) &&
        values.usertypeId === UserTypeValues.CollectionPoint && (
          <p className="text-muted mt-3 mb-2 mx-2">
            (*) Αφήστε το όνομα του σημείου συλλογής κενό ώστε να δηλώσει ο χρήστης τα στοιχεία του
            σημείου συλλογής.
          </p>
        )}
    </>
  );
};
